import { render, staticRenderFns } from "./HaberArsiv.vue?vue&type=template&id=2d538b89&scoped=true&"
import script from "./HaberArsiv.vue?vue&type=script&lang=js&"
export * from "./HaberArsiv.vue?vue&type=script&lang=js&"
import style0 from "./HaberArsiv.vue?vue&type=style&index=0&id=2d538b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d538b89",
  null
  
)

export default component.exports